import React, { useEffect, useState } from "react";
import { useMsal } from "@azure/msal-react";
import { useDispatch, useSelector } from "react-redux";
import { FaRegWindowClose } from "react-icons/fa";
import {
  getCapability,
  getCategory,
  getUserData,
} from "../../Redux/UserDetails";
import {
  Card,
  CardContent,
  Typography,
  Avatar,
  Box,
  Button
} from "@mui/material";
import { BASE_API_URL } from "../../utils/constants";
import EditProfileDialog from "../../FunctionalComponents/EditProfileDialog";
import { useRef } from "react";
import "./MyProfile.css";

function MyDetails({ onClose }) {
  const { instance } = useMsal();
  const dispatch = useDispatch();
  const userData = useSelector((state) => state.userDetails.userData[0]);
  const loader = useSelector((state) => state.userDetails.loader);
  const [openEdit, setOpenEdit] = useState(false);
  const [photo, setPhoto] = useState();
  const [preview, setPreviewUrl] = useState();
  const capabilities = useSelector((state) => state.userDetails.capabilities);
  const category = useSelector((state) => state.userDetails.category);
  const fileInputRef = useRef(null);

  const activeAccount = instance.getActiveAccount();
  let loggedInEnterpriseId = "";
  let userName = "";
  let userDesignation = "";
  let userLevel = "-";
  if (activeAccount) {
    loggedInEnterpriseId = activeAccount.idTokenClaims.enterpriseID;
    userName = activeAccount.idTokenClaims.name;
    userDesignation = activeAccount.idTokenClaims.jobTitle;
    userLevel = activeAccount.idTokenClaims.jobFamilyDescription;
  }

  const [photoUrl, setPhotoUrl] = useState(null);
  const fetchPhoto = async () => {
    try {
      const photoResponse = await fetch(
        "https://graph.microsoft.com/v1.0/me/photo/$value",
        {
          headers: {
            Authorization: localStorage.getItem("token"),
          },
        }
      );
      if (photoResponse.status !== 200) {
        return;
      }
      const blob = await photoResponse.blob();
      setPhotoUrl(URL.createObjectURL(blob));
    } catch (error) {
      console.error("Error fetching profile photo", error);
    }
  };

  useEffect(() => {
    fetchPhoto();
  }, []);

  useEffect(() => {
    dispatch(getUserData(loggedInEnterpriseId));
    dispatch(getCapability(loggedInEnterpriseId));
    dispatch(getCategory(loggedInEnterpriseId));
  }, [loggedInEnterpriseId]);

  if (loader) return <Typography>Loading...</Typography>;
  if (!userData) return <Typography>No user data found</Typography>;

  const getInitials = (name = "") => {
    const parts = name.trim().split(" ");
    if (parts.length === 1) return parts[0][0];
    return `${parts[0][0]}${parts[parts.length - 1][0]}`;
  };

  const handleDivClick = () => {
    fileInputRef.current.click();
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const objectUrl = URL.createObjectURL(file);

    console.log("Selected file:", file);
    setPreviewUrl(objectUrl);
    setPhoto(file);
  };

  const isEmpty = (value) =>
    value === null ||
    value === undefined ||
    value === "" ||
    value === "NULL";

  const isProfileIncomplete =
    isEmpty(userData?.capability) ||
    isEmpty(userData?.industry) ||
    isEmpty(userData?.category) ||
    isEmpty(userData?.role);

  return (
    <Box
      minHeight="fit-content"
      display="flex"
      flexDirection="column"
      justifyContent="space-between"
      px={{ xs: 1.5, sm: 2, md: 3 }}
      sx={{
        background: "linear-gradient(135deg, #f5f7fa 0%, #e4ebf5 100%)",
        width: "100%",
      }}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          py: 1.5,
        }}
      >
        <Typography
          sx={{
            fontWeight: 600,
            fontSize: { xs: "16px", sm: "20px" },
          }}
        >
          Profile
        </Typography>

        <Box
          onClick={onClose}
          sx={{
            cursor: "pointer",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            width: 32,
            height: 32,
            borderRadius: "50%",
            transition: "0.2s",
            "&:hover": {
              backgroundColor: "#f0f0f0",
            },
          }}
        >
          <FaRegWindowClose size={20} />
        </Box>
      </Box>

      <Card
        sx={{
          width: "100%",
          maxWidth: { xs: 360, sm: 410, md: 450, borderRadius: "0px" },
          position: "relative",
          boxShadow: "2px solid lightgrey",
          marginBottom: "2rem",
        }}
      >
        <img
          style={{
            position: "absolute",
            right: "0.5em",
            top: "4em",
            width: "3.2em",
          }}
          src={process.env.PUBLIC_URL + "/Assets/homeMedal.png"}
        />

        <CardContent
          sx={{
            padding: "0px",
          }}
        >
          <p
            style={{
              height: "3.2em",
              background: "linear-gradient(0.25turn, #210224, #5F4987)",
              marginBottom: "0px",
              marginTop: "0px",
              width: "100%",
              background: "linear-gradient(0.25turn, #210224, #5F4987)",
            }}
          ></p>

          <Box
            display="flex"
            justifyContent="space-around"
            position="relative"
            sx={{
              padding: "35px 35px 35px 0px",
              width: "90%",
              margin: "auto",
            }}
          >
            <Avatar
              src={
                photoUrl ||
                preview ||
                (userData?.photo
                  ? `${BASE_API_URL}/${userData?.photo}`
                  : undefined)
              }
              sx={{
                width: { xs: 85, sm: 99, md: 111 },
                height: { xs: 85, sm: 99, md: 111 },
                borderRadius: "50%",
                border: "3px #e1d9d9 solid",
                overflow: "hidden",
                background:
                  "linear-gradient(0.25turn, rgb(33, 2, 36), rgb(95, 73, 135))",
              }}
            >
              {!userData.photo && !photo && getInitials(userData.name)}
            </Avatar>

            {openEdit && (
              <>
                <div
                  onClick={handleDivClick}
                  style={{
                    position: "absolute",
                    height: "1.5em",
                    zIndex: "99",
                    width: "1.5em",
                    cursor: "pointer",
                    bottom: "50px",
                    left: "70px",
                    borderRadius: "50%",
                    color: "#fff",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontWeight: "bold",
                  }}
                >
                  <img
                    width={25}
                    src={process.env.PUBLIC_URL + "/Assets/UploadImage.png"}
                  />
                </div>

                <input
                  type="file"
                  ref={fileInputRef}
                  style={{ display: "none" }}
                  accept="image/*"
                  onChange={handleFileChange}
                />
              </>
            )}

            <div
              style={{
                display: "flex",
                flexDirection: "column",
                padding: "0em 0.5em",
                width: "80%",
              }}
            >
              <Typography
                variant="h5"
                textAlign="center"
                sx={{
                  fontSize: "14px",
                  fontWeight: "600",
                  fontStyle: "Graphik-Semibold",
                  width: "100%",
                  textAlign: "left",
                  color: "#000000",
                }}
              >
                {userData.name === "NULL" || userData.name === ""
                  ? userName
                  : userData.name}
              </Typography>
              <p
                style={{
                  fontSize: "1em",
                  color: "#555555",
                  "margin-bottom": "0px",
                }}
              >
                {userDesignation}
              </p>
              <hr style={{ margin: "8px 0px" }} />
              <p
                style={{
                  fontSize: "1em",
                  color: "#555555",
                  "margin-bottom": "0px",
                }}
              >
                <span style={{ "font-weight": "600" }}>Level:</span> {userLevel}
              </p>
              <p style={{ fontSize: "1em", color: "#555555" }}>
                <span style={{ "font-weight": "600" }}>Role:</span>{" "}
                {userData.role}
                {!openEdit && (
                  <img
                    style={{
                      margin: "0px 0px 5px 5px",
                      cursor: "pointer",
                      "vertical-align": "top",
                    }}
                    width={20}
                    src={process.env.PUBLIC_URL + "/Assets/Edit-profile.svg"}
                    alt="Edit Details"
                    onClick={() => setOpenEdit(true)}
                  />
                )}
                {openEdit && (
                  <FaRegWindowClose
                    style={{
                      color: "blueviolet",
                      "margin-left": "6px",
                      cursor: "pointer",
                      "vertical-align": "sub",
                    }}
                    onClick={() => setOpenEdit(false)}
                  />
                )}
              </p>
            </div>
          </Box>
          {isProfileIncomplete && (
            <Box
              sx={{
                p: 1.5,
                m: 2,
                mt: -4,
                backgroundColor: "#fff3f3",
                border: "1px solid #ffcdd2",
              }}
            >
              <p style={{ margin: 0, fontSize: "0.9em", color: "#b71c1c" }}>
                Please complete your profile for viewing courses.
                <br />
                Add your <b>Digital Customer, Industry, Category and Role</b> data.
              </p>
            </Box>
          )}
          {openEdit && (
            <>
              <hr
                style={{ width: "90%", margin: "auto", color: "#acacacff" }}
              />
              <EditProfileDialog
                // open={openEdit}
                onClose={() => setOpenEdit(false)}
                capabilities={capabilities}
                category={category}
                user={userData}
                photo={photo}
              />
            </>
          )}
        </CardContent>
      </Card>
    </Box>
  );
}

export default MyDetails;
